import styled from 'styled-components';

export const RemoveLineItemWrapper = styled.div`
  cursor: pointer;
  &:hover {
    color: red;
  }
`;
